// @flow
import React, { useMemo } from "react";
import { Provider } from "react-redux";
import DocumentTitle from "react-document-title";
import NotificationsContainer from "../../containers/NotificationsContainer";
import CreateMessageGroupContainer from "../../containers/CreateMessageGroup";
import configureStore from "./store";

function CreateMessageGroup() {
  const store = useMemo(configureStore, []);

  return (
    <DocumentTitle title="Message Group">
      <Provider store={store}>
        <NotificationsContainer />
        <CreateMessageGroupContainer />
      </Provider>
    </DocumentTitle>
  );
}

export default CreateMessageGroup;
